import { render, staticRenderFns } from "./ZCcunliangzichanfenlei2.vue?vue&type=template&id=f9d55c36&scoped=true"
import script from "./ZCcunliangzichanfenlei2.vue?vue&type=script&lang=js"
export * from "./ZCcunliangzichanfenlei2.vue?vue&type=script&lang=js"
import style0 from "./ZCcunliangzichanfenlei2.vue?vue&type=style&index=0&id=f9d55c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d55c36",
  null
  
)

export default component.exports